<script>
	import BookingModalTab from "./BookingModalTab.svelte";
	export let issues;
</script>

<BookingModalTab tab={"exterior"} {issues} {$$props} />
